<div class="countdown-timer" *ngIf="timeDifference > 0">
    <div class="time-unit">
      <span>{{ timeLeft.days }}</span>
      <span class="days">Dias</span>
    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <span>{{ timeLeft.hours }}</span>
      <span class="days">Horas</span>

    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <span>{{ timeLeft.minutes }}</span>
      <span class="days">Minutos</span>

    </div>
    <div class="separator">:</div>
    <div class="time-unit">
      <span>{{ timeLeft.seconds }}</span>
      <span class="days">Segundos</span>

    </div>
</div>
